import { render, staticRenderFns } from "./center-modal.vue?vue&type=template&id=69be076d"
import script from "./center-modal.vue?vue&type=script&lang=js"
export * from "./center-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports